import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import Pagination from "../Pagination";
import { useDispatch, useSelector } from "react-redux";
import {
  makeAjax,
  respStatus,
  showMessage,
  url,
  arrayGuess,
} from "../../../../helpers/global_helper";
import { setTotalNoResult } from "../../../../redux/actions";
import InfoResultLinkPopup from "./InfoResultLinkPopup";
import { withTranslation } from "react-i18next";

const InformasiResultPopup = (props) => {
  const { onClose } = props;
  const dispatch = useDispatch();
  const [listResultInformation, setListResultInformation] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const pageNumber = useSelector((state) => state.paginationData.pageNumber);
  const [loading, setLoading] = useState(false);
  const [resultPopup, setResultPopup] = useState(false);
  const [selectedResultData, setSelectedResultData] = useState(null);
  const [siteUrl, setSiteUrl] = useState();
  const [fullUrl, setFullUrl] = useState();
  const [gameCode, setGameCode] = useState();
  useEffect(() => {
    setLoading(true);
    const reqData = {
      game_id: gameId,
      page: pageNumber,
    };
    makeAjax(
      url.TOGEL_API.listResultInformation,
      reqData,
      url.TOGEL_MS_EXT
    ).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response.message);
        return;
      }
      setListResultInformation(response.data.results.data);
      setGameCode(response.data.game.game_code);
      dispatch(setTotalNoResult(response.data.results.total));
      setSchedule(response.data.schedule);
      let siteUrl = arrayGuess("siteTG", response.data.game.game_code);
      const fullUrl = `http://${siteUrl}`;
      setFullUrl(fullUrl);
      setSiteUrl(siteUrl);
      setLoading(false);
    });
  }, [pageNumber]);

  const calculateTimeWithOffset = (time, offsetSeconds) => {
    const [hour, minute] = time.split(":").slice(0, 2).map(Number);
    const timeInSeconds = hour * 3600 + minute * 60 + offsetSeconds;
    const newHour = Math.floor(timeInSeconds / 3600) % 24;
    const newMinute = Math.floor((timeInSeconds % 3600) / 60);
    return `${String(newHour).padStart(2, "0")}:${String(newMinute).padStart(
      2,
      "0"
    )}`;
  };

  const handleResultClick = (date, period, number) => {
    const reqData = {
      game_id: gameId,
      number: number,
      period: period,
      datetime: date,
    };

    makeAjax(
      url.TOGEL_API.getResultInformation,
      reqData,
      url.TOGEL_MS_EXT
    ).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response.message);
        return;
      }
      setSelectedResultData(response.data);
      setResultPopup(true);
    });
  };
  const locale = props.i18n.language;
  const prize123Status = useSelector((state) => state.CommonConfig.discount.prize123Status);

  return (
    // <div className="overlay">
    //   <div className="informasi_popup">
    //     <button className="informasi_popup-close" onClick={onClose}>
    //       <IoMdClose className="btnclose" />
    //     </button>
    <>
      {/* <div className="result_txt">RESULT</div> */}
      <div className="main_result">
        <div className="left_result">
          {schedule.length > 1 && (
            <p>
              {props.t("close_market")} : {schedule[0].time.slice(0, 5)} WIB
            </p>
          )}
          <p>
            {props.t("official_site")} : {" "}      
            <a
              href={fullUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="result-link"
            >
              {siteUrl}
            </a>
            {/* {" "} */}
            {/* <span style={{ textDecoration: "underline" }}>
                {" "}
                {siteUrl}
              </span> */}
          </p>
          <p className="datatxt">{props.t("data_number")}</p>
        </div>
        <div className="right_result">
          <p>
            {props.t("open_result")}:{" "}
            <span className="bluetxt_color">
              {schedule[1]?.time &&
                schedule[1].time.split(":").slice(0, 2).join(":")}{" "}
              WIB{" "}
            </span>
            |
            <span className="bluetxt_color">
              {" "}
              {schedule[1]?.time &&
                calculateTimeWithOffset(schedule[1].time, 3600)}{" "}
              WITA
            </span>{" "}
            |
            <span className="bluetxt_color">
              {" "}
              {schedule[1]?.time &&
                calculateTimeWithOffset(schedule[1].time, 7200)}{" "}
              WIT
            </span>
          </p>
        </div>
      </div>
      {/* table */}
      <div className="informasi_tble_result">
        <table>
          <thead>
            <tr>
              <th>{props.t("date")}</th>
              <th>{props.t("day")}</th>
              <th>{props.t("period")}</th>
              <th>{props.t("result")}</th>
              {prize123Status === 1 && <th>{props.t("result")}2</th>}
              {prize123Status === 1 && <th>{props.t("result")}3</th>}            

            </tr>
          </thead>
          <tbody>
            {!loading &&
              listResultInformation.map((data, index) => {
                const date = new Date(data.datetime);
                const format = locale === "id" ? "id-ID" : "en-US";
                const day = date.toLocaleDateString(format, {
                  weekday: "long",
                });
                return (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "even-row" : "odd-row"}
                  >
                    <td>{data.datetime.split(" ")[0]}</td>
                    <td>{day}</td>
                    <td>{data.period}-{gameCode}</td>
                    {/* <td onClick={()=>setResultPopup(true)}> */}
                    <td
                      onClick={() =>
                        handleResultClick(
                          data.datetime.split(" ")[0],
                          data.period,
                          data.number
                        )
                      }
                    >
                      <span className="link">{data.number}</span>
                    </td>
                    {prize123Status === 1 && <td>{data.number2}</td>}
                    {prize123Status === 1 && <td>{data.number3}</td>}

                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      <Pagination />
      {resultPopup && (
        <InfoResultLinkPopup
          response={selectedResultData}
          onClose={() => setResultPopup(false)}
        />
      )}</>
    //   </div>
    // </div>
  );
};

export default withTranslation()(InformasiResultPopup);
